import React from 'react'

import { MotiView as MV } from 'moti'
import { useReducedMotion } from 'react-native-reanimated'

type Props = React.ComponentProps<typeof MV>

export const MotiView = (props: Props) => {
  const { animate, transition, onDidAnimate, ...rest } = props

  const reducedMotion = useReducedMotion()
  const _animate = reducedMotion ? undefined : animate
  const _transition = reducedMotion ? undefined : transition
  const _onDidAnimate = reducedMotion ? undefined : onDidAnimate

  return (
    <MV
      {...rest}
      animate={_animate}
      transition={_transition}
      onDidAnimate={_onDidAnimate}
    />
  )
}
